import { Box, Button, Chip, Link, Stack, styled, Typography } from '@mui/joy';
import { css } from '@mui/system';
import { createFileRoute, Link as RouterLink, useNavigate } from '@tanstack/react-router';

import ClockIcon from '@/assets/icons/clock-countdown.svg?react';
import { LogoutForm } from '@/components/authentication/LogoutForm';
import { NotificationsTable } from '@/components/processes/table/NotificationsTable';
import { I18N_DE } from '@/i18n/de';
import { UserGuard } from '@/modules/UserGuard';
import { useProcessesQuery } from '@/queries/useProcessesQuery';
import { useUserQuery } from '@/queries/useUserQuery';

export const Root = styled(Box)(
  ({ theme }) => css`
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: ${theme.palette.neutral[50]};
    align-items: center;
    padding: ${theme.spacing(4)};
  `,
);

export const LinkButton = styled(Button)(
  () => css`
    padding: 0;
    min-height: fit-content;
    &:hover {
      background: none;
      text-decoration: underline;
      text-underline-offset: 0.15em;
    }
  `,
);

export const StyledButton = styled(Button)(
  () => css`
    display: flex;
    flex-direction: column;
    flex: 0.3 0.3 0px;
    align-content: center;
  `,
);

function RouteComponent() {
  const { data: user } = useUserQuery();
  const { data: processes } = useProcessesQuery();
  const navigate = useNavigate();

  return (
    UserGuard.isUser(user) && (
      <Root>
        <Stack maxWidth="xl" width="100%" gap={2} minWidth={1000}>
          <Stack direction="row" alignItems="center" gap={2}>
            <Typography level="h1">{`${user.firstName} ${user.lastName}`}</Typography>
            <Link component={RouterLink} to="/profil/edit">
              <Typography level="body-md" color="primary">
                Profil bearbeiten
              </Typography>
            </Link>
            <LogoutForm>
              <LinkButton type="submit" size="sm" variant="plain">
                <Typography level="body-md" color="primary">
                  Logout
                </Typography>
              </LinkButton>
            </LogoutForm>
          </Stack>

          <Stack direction="row" gap={1}>
            {user.organization && (
              <Chip size="md" color="primary" variant="outlined">
                {`${I18N_DE.OrganizationUserRole[user.organization.role]} ${user.organization.organization?.name}`}
              </Chip>
            )}
            <Chip size="md" color="primary" variant="outlined">
              {`VZK ${I18N_DE.UserRole[user.role]}`}
            </Chip>
          </Stack>

          <Stack direction="row" gap={1}>
            <StyledButton
              color="primary"
              variant="soft"
              onClick={() => {
                navigate({
                  to: '/vorgaenge/$adminLevelId',
                  params: {
                    adminLevelId: user.organization?.organization?.adminLevels?.[0]
                      ? user.organization.organization.adminLevels[0].adminLevelId
                      : 'recherche',
                  },
                });
              }}
            >
              <Typography level="h2">{processes?.length || 0}</Typography>
              <Stack direction="row" gap={1}>
                <ClockIcon width={24} height={24} />
                <Typography color="primary">Verfahren</Typography>
              </Stack>
            </StyledButton>
          </Stack>

          <NotificationsTable />
        </Stack>
      </Root>
    )
  );
}

export const Route = createFileRoute('/_authenticated/_management/profil/')({
  component: RouteComponent,
});
